/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsPaymentInitOutput } from "../../entities/models/PaymentInitOutput";
import { z } from "zod/v4";

export const modelsPaymentInitOutputSchema = z.object({
    "amount": z.optional(z.number()),
"confirmation_url": z.optional(z.string()),
"payment_id": z.optional(z.int()),
"status": z.optional(z.string())
    }) as unknown as z.ZodType<ModelsPaymentInitOutput>